import React from 'react'
import './index.css'
import {BrandLogoPartner} from '../../../assets/image/index'
import { Container } from 'react-bootstrap'

const OptionBrand = () => {
  return (
    <div className='option-brand align-items-center justify-content-center'>
        <Container>
        <div className='text-center'>
        <h1 className="title">BERBAGAI PILIHAN BRAND TERBAIK DUNIA</h1> 
        <p className='p'>HUBExpress Didukung Oleh Berbagai Pilihan Brand Terbaik & Terfavorit Di Dunia !</p>      
        <img src={BrandLogoPartner} className='brand-logo-partner'/>
        </div>


        </Container>
    </div>
  )
}

export default OptionBrand